import _extends from "@babel/runtime/helpers/extends";
/**
 * Note: Do not use this non-form component in your form. Use the core/form/components/Checkbox instead.
 */
import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { display, space, width } from 'styled-system';
import { Checkbox as BlueprintCheckbox, Classes } from '@blueprintjs/core';
import { formAriaProps, guessByChildText } from '../util/ariaUtils';
const StyledCheckbox = styled(BlueprintCheckbox).withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-13movhy-0"
})(["&&{&.", "{", ";", ";", "}&.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{background-image:none;filter:grayscale(1);}", "}"], Classes.CONTROL, space, width, display, props => !props.labelElement && !props.label && css(["padding-left:16px;.bp4-control-indicator{margin-left:-16px;margin-right:0;}"]));
const Checkbox = observer(props => {
  // TODO move this into function declaration, can't do it right now since it messes up rename operation
  const {
    m = 0,
    mb = '2px',
    onChange = () => {},
    alignItems: _alignItems = 'center',
    display: _display = 'flex',
    ariaLabel,
    className,
    small,
    readOnly,
    style,
    ...rest
  } = props;
  const handleChange = e => {
    if (!readOnly) {
      onChange(e.currentTarget.checked);
    }
  };
  const handleKeyDown = e => {
    // note space us handled by blueprint
    if (e.key === 'Enter') {
      if (!readOnly) {
        onChange(e.currentTarget.checked);
      }
    }
  };
  const ariaLabelGuess = guessByChildText(rest.labelElement) || rest?.label;
  const ariaProps = formAriaProps(rest, {
    ariaLabel: ariaLabel || ariaLabelGuess,
    ariaSelected: readOnly
  }, {
    enableTabIndexNotDisabled: true,
    passOnExistingAria: true
  });
  return /*#__PURE__*/React.createElement(StyledCheckbox, _extends({}, ariaProps, rest, {
    m: m,
    mb: mb,
    display: _display,
    onKeyDown: handleKeyDown,
    className: classNames(className, {
      [Classes.SMALL]: small
    }),
    onChange: handleChange
    // Can't set alignItems directly on StyledCheckbox as React complains
    ,
    style: {
      alignItems: _alignItems,
      ...style
    }
  }));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;